import ProductZone from './productZone';

const url = window.location.href;
const external = 'utm_source';
const placement = 'item_page';
const landingZoneForExternalUrl = `${placement}.h0_PPC`;
const landingZoneForInternalUrl = `${placement}.h0_nonPPC`;
const isExternalUrl = url.includes(external);

export function findZonesInDomNode(DomNode = document) {
	return DomNode.querySelectorAll('[data-related-product-zone]');
}

export function prepareZonesToRender(allProductZonesOnPDP) {
	const productZoneElementsToRender = [];

	for (let i = 0; i < allProductZonesOnPDP.length; i++) {
		const productZoneElement = allProductZonesOnPDP[i];
		const productZonePlacement = productZoneElement.dataset.relatedProductZone;
		const isNotLandingZone =
			productZonePlacement !== landingZoneForExternalUrl &&
			productZonePlacement !== landingZoneForInternalUrl;

		if (
			isNotLandingZone ||
			(productZonePlacement === landingZoneForExternalUrl && isExternalUrl) ||
			(productZonePlacement === landingZoneForInternalUrl && !isExternalUrl)
		) {
			productZoneElementsToRender.push(productZoneElement);
		}
	}

	return productZoneElementsToRender;
}

export function buildZoneList(zoneElements) {
	const productZones = {};
	const zoneIds = [];
	let zoneName = '';
	const h1Zone = `${placement}.h1`;
	const siteFlashBanner = document.getElementById('siteFlash');
	const display = 'd-none';
	let externalVisitor = false;

	for (let i = 0; i < zoneElements.length; i++) {
		const zoneElement = zoneElements[i];

		const newZone = new ProductZone(zoneElement);
		zoneName = newZone.placmentId;

		if (
			(zoneName === landingZoneForExternalUrl && isExternalUrl) ||
			(zoneName === landingZoneForInternalUrl && !isExternalUrl)
		) {
			siteFlashBanner?.classList.add(display);
		}

		if (zoneName === landingZoneForExternalUrl && isExternalUrl) {
			externalVisitor = true;
		}

		if (zoneName !== h1Zone || (zoneName === h1Zone && !isExternalUrl)) {
			productZones[zoneName] = newZone;
			zoneIds.push(zoneName);
		}
	}

	return {
		productZones,
		zoneIds,
		externalVisitor,
	};
}

export function renderZones(productZones, results, externalVisitor) {
	const zoneRenderRequests = [];

	results?.forEach(zoneResult => {
		if (productZones[zoneResult.zoneId]) {
			productZones[zoneResult.zoneId].addResults(zoneResult);
			zoneRenderRequests.push(
				productZones[zoneResult.zoneId].requestRender(externalVisitor),
			);
		}
	});

	return Promise.all(zoneRenderRequests);
}
